module.exports = "/images/Create packages - 3.jpg";